import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

/**
 * Initialize window.Echo from the Inertia `socket` shared prop when a realtime
 * driver is configured. No-op when driver is null/undefined (the default,
 * BROADCAST_DRIVER=null) so the app stays fully functional without a server.
 *
 * The socket prop is shared by HandleInertiaRequests:
 *   { driver, key, host, port, scheme, cluster, useTLS }
 *
 * Guarded for SSR (no window) and for absent driver. Importing this module is
 * always safe; it only attaches window.Echo / window.Pusher when appropriate.
 */
export function initEcho(socket) {
    if (typeof window === 'undefined') return
    if (!socket || !socket.driver) return
    if (window.Echo) return

    const driver = socket.driver
    if (driver !== 'reverb' && driver !== 'pusher') return

    window.Pusher = Pusher

    const options = {
        broadcaster: driver,
        key: socket.key,
        wsHost: socket.host,
        wsPort: socket.port,
        wssPort: socket.port,
        forceTLS: !!socket.useTLS,
        disableStats: true,
        enabledTransports: ['ws', 'wss'],
    }

    if (driver === 'reverb') {
        // Reverb lacks clusters; allow scheme override via the socket prop.
        options.scheme = socket.scheme || 'https'
    } else if (socket.cluster) {
        options.cluster = socket.cluster
    }

    window.Echo = new Echo(options)
}
